<template>
  <client-only>
    <div class="container">
      <div class="top">
        <div class="content">
          <div class="left">
            <div class="banner-container">
              <template v-if="$ThemeManager.isDivasTheme()">
                <router-link :to="{name: 'home'}">
                    <div class="logo"></div>
                </router-link>
              </template>

              <template v-else>
                <div class="logo-container">
                  <div class="logo-top-side">
                    <router-link :to="{name: 'home'}">
                        <img class="logo-chads" src="/img/themes/chads/logo.png" alt="Chads logo" />
                    </router-link>
                  </div>
                  <div class="logo-bottom-side">
                    <div class="text">by</div>
                    <router-link :to="{name: 'home'}">
                        <img class="logo-divas" src="/img/logo.png" alt="Divas logo" />
                    </router-link>
                  </div>
                </div>
              </template>

            </div>

            <!-- <div class="social-media viewport-mobile">
              <AppDivasSocials />
            </div> -->
          </div>

          <div class="right">
            <div class="social-media">
              <AppDivasSocials />
            </div>

            <div class="language-selector">
              <LanguageSelector />
            </div>

            <div class="profile-circle-container">
              <AppProfileCircle />
            </div>
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="link-container">
          <router-link class="item" :style="customStyle()" :to="{ name: 'home' }">
            {{ $t("header.home") }}
          </router-link>

          <AppNavLogin :style="customStyle()" />

          <router-link
            v-if="filtersActive"
            class="item"
            :style="customStyle()"
            :to="{ name: 'webstars.search' }"
          >
            {{ $t("header.filters") }}
          </router-link>

          <router-link
            class="item"
            :style="customStyle()"
            :to="{ name: 'purchase.tokens' }"
          >
            {{ $t("header.tokens") }}
          </router-link>
        </div>

        <SearcherModelInput class="SearcherModel" />
      </div>
    </div>
  </client-only>
</template>

<script setup lang="ts">
import _NuxtApp from "~/types/NuxtApp";

import LanguageSelector from "./Header.LanguageSelector.vue";

const { $ThemeManager } = <_NuxtApp>useNuxtApp();

const $config = useRuntimeConfig().public;

const filtersActive = $config.VUE_APP_ACTIVE_FILTERS === "true" || false;
const isDesktop = ref(false);

function customStyle() {
  let elements = filtersActive ? 4 : 3;
  return {
    flexBasis: `calc(100% / ${elements} - 1px)`,
  };
}

function checkDesktop() {
  isDesktop.value = window && window.innerWidth > 768;
}

onMounted(() => {
  checkDesktop();
  window.addEventListener("resize", checkDesktop);
});
</script>

<style scoped lang="scss">
@import "@/assets/scss/variables.scss";

.viewport-mobile {
  @media (min-width: 768px) {
    display: none !important;
  }
}

.viewport-desktop {
  @media (max-width: 768px) {
    display: none !important;
  }
}

.top {
  // background-color: var(--pallete_dark_color-lighten-15);
  background-color: var(--pallete_dark_color);
  // filter: brightness(1.15);
  color: var(--pallete_clear_text_color);

  .logo {
    height: 44px;
    width: 465px;
    background-image: var(--img-logo);
    background-size: contain;
    background-position: left;
    background-repeat: no-repeat;

    @media (max-width: 900px) {
      width: 100%;
      height: 30px;
      // background-position: center;
    }
  }

  .content {
    padding-block: 20px;
    // padding-right: 0.5em;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    
    @media (max-width: 900px) {
      padding-inline: 20px;
    }

    .left {
      display: flex;
      flex-flow: column;

      @media (max-width: 900px) {
        flex-grow: 1;
      }

      .banner-container {
        display: flex;
        flex-grow: 1;

        a {
          width: 100%;
        }
      }

      .social-media {
        justify-content: flex-start;
        width: fit-content;
      }
    }

    .right {
      flex-shrink: 1;
      display: flex;
      align-items: center;

      height: fit-content;

      .language-selector {
        background-color: var(--pallete_dark_color);
        float: left;
        // height: 36px;
        display: flex;
        text-align: center;
        margin: 0 1em 0 0;

        @media (max-width: 767px) {
          margin: 0 0.5em 0 0;
        }

        // @media (max-width: 900px) {
        //   background-color: transparent;
        //   display: block;
        // }
      }

      @media (max-width: 767px) {
        .social-media, .language-selector, .profile-circle-container {
          height: 30px;
        }
      //   flex-direction: column-reverse;

      //   .language-selector {
      //     margin: 0.5em 0 0 0;
      //   }
      }
    }
  }
}

.bottom {
  display: flex;
  flex-direction: row;
  // justify-content: space-evenly;

  @media (max-width: 768px) {
    flex-direction: column;

    .SearcherModel {
      width: 100%;
    }
  }

  //   background-color: var(--pallete_dark_color);
  color: var(--pallete_clear_text_color);

  >.link-container {
    display: flex;
    flex-grow: 1;
    flex-direction: row;
    justify-content: space-evenly;

    @media (max-width: 768px) {
      flex-wrap: wrap;

      .SearcherModel {
        width: 100%;
      }
    }

    .item {
      text-align: center;
      color: inherit;
      text-decoration: none;
      text-transform: uppercase;
      font-weight: bold;
      font-size: 16px;
      padding: 0.75em 0;
      flex-grow: 1;
      transition: background-color 0.2s ease-in-out;
  
      &.router-link-active {
        background-color: lighten(#000000, 50);
        color: var(--pallete_dark_color);
      }
  
      // &:hover{
      //     background-color: lighten(#000000, 30);
      // }
  
      &:hover {
        background-color: var(--pallete_clear_text_color);
        color: var(--pallete_dark_color);
      }
  
      &.faqs {
        @media (max-width: 768px) {
          display: none;
        }
      }
    }
  }

}

.social-media {
  display: flex;
  margin-right: 1em;

  @media (max-width: 768px) {
    margin-right: 0.5em;
  }
}

.profile-circle-container {
  display: flex;
}

.logo-container {
  display: flex;
  flex-direction: column;
  height: 44px;

  .text {
    display: block;
    height: min-content;
    // margin-top: auto;
    // font-size: 1.3em;
    font-size: 0.6em;
    font-weight: bold;
  }

  .logo-chads {
    height: 44px;
  }

  .logo-divas {
    height: 25px;
    margin-bottom: 3px;
    margin-top: auto;
  }

  a {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 100%;
    width: min-content !important;
  }

  .logo-top-side, .logo-bottom-side {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  $CHADS_LOGO_SIZE: 32px;
  $DIVAS_LOGO_SIZE: 44px - $CHADS_LOGO_SIZE;
  .logo-top-side {
    height: $CHADS_LOGO_SIZE;
    .logo-chads {
      height: $CHADS_LOGO_SIZE;
      // width: 465px;
    }
  }
  
  .logo-bottom-side {
    height: $DIVAS_LOGO_SIZE;
    justify-content: end;

    .logo-divas {
      height: $DIVAS_LOGO_SIZE;
      // width: 465px;
    }
  }
}

</style>


<style scoped lang="scss">
@import "@/assets/scss/themes/chads";

body.chads {
  .top {
    .logo {
      background-image: url("/img/themes/chads/logo.png");
    }

  }
}
</style>
